import {API_URL} from '../const/api-url.ts';
import {getLocalStorage, removeLocalStorage, setLocalStorage} from './localstorage.util.ts';
import {ApiRequest} from '@wp-content-publisher/typings-lib/dist/src/client/interfaces/api-request.interface.ts';

export const ACCESS_TOKEN_LS_KEY = 'accessToken';

const getToken = () => getLocalStorage(ACCESS_TOKEN_LS_KEY);

const refreshToken = async () => {
    try {
        const res = await fetch(`${API_URL}/auth/refresh`);

        if (!res.ok) {
            throw new Error('Ошибка обновления токена');
        }

        const data: {access_token: string} = await res.json();
        setLocalStorage(ACCESS_TOKEN_LS_KEY, data.access_token);
        return data.access_token;
    } catch (error) {
        console.error('Ошибка обновления токена:', error);
        removeLocalStorage(ACCESS_TOKEN_LS_KEY);
        window.location.href = '/login';
        throw error;
    }
};

export const apiRequest = async (
    {url, queryParams, options, data, controller}: ApiRequest
) => {
    url = `${API_URL}${url}`;
    url = queryParams ? `${url}?${new URLSearchParams(queryParams).toString()}` : url;
    const accessToken = getToken();
    const fetchOptions: RequestInit = {
        ...options,
        headers: {
            ...options?.headers,
            ...(accessToken ? {Authorization: `Bearer ${accessToken}`} : {}),
            ...(['POST', 'PUT'].includes(options?.method as any) ? {'Content-Type': 'application/json'} : {}),
        },
        ...(data ? {body: JSON.stringify(data)} : {}),
        signal: controller?.signal
    };

    let res = await fetch(url, fetchOptions);

    if (res.status === 401 && !url.includes('/auth/login')) {
        try {
            const newAccessToken = await refreshToken();
            fetchOptions.headers = {
                ...fetchOptions.headers,
                Authorization: `Bearer ${newAccessToken}`,
            };
            res = await fetch(url, fetchOptions); // Повторяем запрос с новым токеном
        } catch (err) {
            console.error(err);
        }
    }

    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || `Ошибка ${res.status}`);
    }

    return await res.json();
};
